const SCRIPT_PATTERN = /<script[\s>]|javascript:|on\w+\s*=/i;

export function sanitizeTextInput(value) {
  if (typeof value !== 'string') return '';
  return value.replace(/[<>"'&]/g, (ch) => {
    switch (ch) {
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#x27;';
      case '&': return '&amp;';
      default: return ch;
    }
  });
}

export function isCleanInput(value) {
  if (typeof value !== 'string') return true;
  return !SCRIPT_PATTERN.test(value);
}

export function sanitizeInteger(value, min, max) {
  const num = parseInt(value, 10);
  if (isNaN(num)) return null;
  if (min !== undefined && num < min) return null;
  if (max !== undefined && num > max) return null;
  return num;
}
